<template>
    <div class="slogan bg">
        <div class="slogan-container">
            <div class="slogan-content">
                <h1>杭州市萧山区工程建设招标代理机构诚信库</h1>
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.slogan {
    &-container {
        height: 279px;
    }
    &-content {
        background: url("~@/assets/images/1.png") center center no-repeat;
        background-size: 100% 100%;
        height: 180px;
        text-align: center;
        h1 {
            font-weight: bold;
            font-size: 88px;
            color: #fff;
            line-height: 180px;
        }
    }
}
</style>
